export const ProductTypes = {
  SAVINGS_ACCOUNTS: "SAVINGS ACCOUNTS",
  SAVINGS_ACCOUNTS_ID: 1,
  CREDIT_CARD: "CREDIT CARD ",
  CREDIT_CARD_ID: 4,
  PROD_CAT_CC: "CC",
  PROD_CAT_SA: "SA",
};
